import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import GallerySection from '../components/GallerySection';
import ActivitiesSection from '../components/ActivitiesSection';
import AboutSection from '../components/AboutSection';
import FoundersSection from '../components/FoundersSection';
import RoomsSection from '../components/RoomsSection';
import SightseeingSection from '../components/SightseeingSection';
import MapSection from '../components/MapSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import WhatsAppButton from '../components/WhatsAppButton';
import SplashScreen from '../components/SplashScreen';

const HomePage = () => {
  const [videoReady, setVideoReady] = useState(false);

  React.useEffect(() => {
    // Safety fallback: never let the splash hang indefinitely on very slow networks.
    const timer = setTimeout(() => setVideoReady(true), 15000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0F0E]">
      <SplashScreen isReady={videoReady} />
      <Header />
      <HeroSection onVideoReady={() => setVideoReady(true)} />
      <AboutSection />
      <FoundersSection />
      <RoomsSection />
      <ActivitiesSection />
      <GallerySection />
      <SightseeingSection />
      <MapSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
